import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiInstagram, FiTwitter, FiLinkedin, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-8 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752036442288-burbank-insurance-round-logo.png"
                alt="Burbank Insurance"
                className="w-12 h-12 rounded-full"
              />
              <div>
                <h3 className="text-xl font-bold">Burbank Insurance</h3>
                <p className="text-gray-400 text-sm">CA License #6013543</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6">
              Fast, affordable business insurance for California entrepreneurs.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/burbankinsurance/" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiInstagram} className="text-xl" />
              </a>
              <a href="https://x.com/insurancecali" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiTwitter} className="text-xl" />
              </a>
              <a href="https://www.linkedin.com/in/insurancecalifornia/" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiLinkedin} className="text-xl" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61557663341256" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiFacebook} className="text-xl" />
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-blue-400" />
                <span>(818) 471-4255</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-blue-400" />
                <span>info@burbankinsuranceservices.com</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold mb-4">Coverage</h4>
            <ul className="space-y-2 text-gray-300">
              <li>General Liability</li>
              <li>Professional Liability</li>
              <li>Commercial Property</li>
              <li>Business Interruption</li>
              <li>Cyber Liability</li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h4 className="text-lg font-semibold mb-4">Powered By</h4>
            <div className="bg-white rounded-lg p-4 mb-4">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752036427196-Coterie_Logo_Trans_FullColor-1024x185.png"
                alt="Coterie Insurance"
                className="h-8 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm">
              AM Best A- rated financial strength and innovative technology.
            </p>
          </motion.div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Burbank Insurance Services. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Terms</a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">Licensing</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;